<template>
  <div class="accountmanagement">
    <div class="search-bar">
      <el-button @click="newaccountmanagement" type="primary">+新增账号</el-button>
      <div class="search-box">
        <span class="input-lable">登录账号</span>
        <el-input
          placeholder="请输入内容"
          v-model="searchValue"
          style="width:220px;"
          @keyup.enter.native="goSearch"
        ></el-input>
        <span class="input-lable" style="margin-left:20px;">使用状态</span>
        <el-select v-model="searchStatus" style="width:120px" placeholder="请选择">
          <el-option label="启用" value="on"></el-option>
          <el-option label="禁用" value="off"></el-option>
        </el-select>
        <el-button
          @click="goSearch"
          type="primary"
          style="width:90px;padding:10px;margin-left:8px;"
        >查询</el-button>
        <el-button @click="clearSearch" style="width:60px;padding:10px;">重置</el-button>
      </div>
    </div>
    <div class="table-box">
      <template>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="account" label="登录账号" width="100px"></el-table-column>
          <el-table-column prop="nickname" label="账号联系人" width="100px"></el-table-column>
          <el-table-column prop="role.label" label="角色名称" width="100px"></el-table-column>
          <el-table-column prop="active_status" label="使用状态" width="80px">
            <template slot-scope="scope">
              <span class="enable" v-if="scope.row.active_status">启用</span>
              <span class="prohibit" v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column prop="tele" label="联系人电话" width="180px"></el-table-column>
          <el-table-column prop="email" label="电子邮箱" width="180px"></el-table-column>
          <el-table-column prop="created_time" label="创建时间">
            <template slot-scope="scope">{{scope.row.created_time | formatDate}}</template>
          </el-table-column>
          <el-table-column align="right" prop="active_status" width="150" label="操作">
            <template slot-scope="scope" v-if="scope.row.role.name!=='ROOT'">
              <div class="btn-template">
                <el-button @click="resetpwd(scope.row)" class="btn-span" type="text">重置密码</el-button>
                <span>
                  <el-button
                    @click="editaccountmanagement(scope.row)"
                    class="btn-span"
                    type="text"
                  >编辑</el-button>
                  <el-button
                    @click="delaccountmanagement(scope.row)"
                    class="btn-span"
                    v-show="!scope.row.active_status"
                    type="text"
                  >删除</el-button>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <template>
      <Dialog :dialogData="dialogData" @close-dialogStatus="Close_dialog"></Dialog>
    </template>
  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
import Delete from "./components/deleteMessage";
import EditAccount from "./components/eaitAccount";
import Role from "@/api/RoleModule";
import { formatDate } from "@/assets/js/public";
export default {
  components: { Dialog },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");//hh:mm
    }
  },
  data() {
    return {
      istrue: false,
      searchValue: "",
      searchStatus: "",
      dialogData: {},
      tableData: [],
      eaitData: {},
      dialogType: ""
    };
  },
  methods: {
    goSearch() {
      //模糊查询
      var datas = `page=${1}${
        this.searchValue ? "&search=" + this.searchValue : ""
      }${this.searchStatus ? "&status=" + this.searchStatus : ""}`;
      Role.searchMemberList(datas) //
        .then(res => {
          this.tableData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clearSearch() {
      //清除
      this.searchValue = "";
      this.searchStatus = "";
      this.getMemberData();
    },
    newaccountmanagement() {
      this.dialogData = {
        title: "新建账号",
        dialogVisible: true,
        width: "453px",
        buttonNum: true,
        render: (h, scope) => {
          var that = this;
          return this.$createElement(EditAccount, {
            ref: "cli",
            props: {
              roleData: {},
              dialogType: "new",
              isdisabled: false
            },
            on: {
              datamaseg(el, dialogType, istrue) {
                that.istrue = istrue;
                that.dialogType = dialogType;
                that.eaitData = el;
                that.callback_fun();
              }
            }
          });
        }
      };
    },
    editaccountmanagement(data) {
      this.dialogData = {
        title: "编辑",
        dialogVisible: true,
        width: "453px",
        buttonNum: true,
        render: (h, scope) => {
          var that = this;
          return this.$createElement(EditAccount, {
            ref: "cli",
            props: {
              roleData: data,
              dialogType: "edit",
              isdisabled: data.active_status ? true : false
            },
            on: {
              datamaseg(el, dialogType, istrue) {
                that.istrue = istrue;
                that.dialogType = dialogType;
                that.eaitData = el;
                that.callback_fun();
              }
            }
          });
        }
      };
    },
    delaccountmanagement(data) {
      this.dialogData = {
        title: "",
        dialogVisible: true,
        width: "453px",
        buttonNum: true,
        render: (h, scope) => {
          var that = this;
          return this.$createElement(Delete, {
            ref: "cli",
            props: {
              roleData: data,
              dialogType: "del",
              name:'登录账号'
            },
            on: {
              datamaseg(el, dialogType, istrue) {
                that.istrue = istrue;
                that.dialogType = dialogType;
                that.eaitData = el;
                that.callback_fun();
              }
            }
          });
        }
      };
    },
    resetpwd(data) {
      Role.resetPwd(data.id) //
        .then(res => {
          this.$message({
            type: "success",
            message: "密码重置成功，请使用新密码登录!"
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "网络异常，请稍后再试"
          });
        });
    },
    callback_fun() {
      var that = this;
      if (that.istrue === "false" || that.istrue === false) return false;
      var id = this.eaitData.id;
      var datas = {
        account: this.eaitData.account_,
        nickname: this.eaitData.nickname_,
        password: this.eaitData.password,
        role_id: this.eaitData.role_id,
        tele: this.eaitData.tele_,
        email: this.eaitData.email_,
        active_status: this.eaitData.status
      };
      if (this.dialogType === "new") {
        Role.addMember(datas) //
          .then(res => {
            that.dialogData["dialogVisible"] = false;
          })
          .catch(err => {
            if (err.data.status === 201) {
              this.$message.error(err.data.error);
              that.$refs.cli.accountReg("datas");
            }
          });
      } else if (this.dialogType === "edit") {
        if (that.eaitData["status"] === false) {
          delete datas["active_status"];
        }
        delete datas["password"];
        Role.modifyMember(id, datas) //
          .then(res => {
            that.dialogData["dialogVisible"] = false;
          })
          .catch(err => {
            if (err.data.status === 201) {
              this.$message.error(err.data.error);
              // that.$refs.cli.accountReg('datas')
            }
          });
      } else {
        Role.deleteMember(id) //
          .then(res => {
            that.dialogData["dialogVisible"] = false;
          })
          .catch(err => {
            if (err.data.status === 201) {
              this.$message.error("启用状态不可以删除");
            }
          });
      }
      setTimeout(function() {
        that.getMemberData();
      }, 500);
    },
    Close_dialog() {
      //处理组件
      this.$refs.cli.Submission("datas");
    },
    getMemberData() {
      Role.getMemberList() //获取用户列表数据
        .then(res => {
          this.tableData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {},
  mounted() {
    this.getMemberData();
  }
};
</script>
<style scoped>
.search-bar {
  position: absolute;
  top: 84px;
  width: 1028px;
  height: 78px;
  background: #ffffff;
  border-radius: 5px;
  padding: 0 30px 0 22px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.search-box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.input-lable {
  width: 59px;
  height: 19px;
  font-size: 14px;
  color: #666666;
  line-height: 19px;
}
.table-box {
  /* position: absolute; */
  width: 1020px;
  min-height: 600px;
  /* top: 162px; */
  /* bottom: 0; */
  /* overflow: auto; */
  background: #fff;
  border-radius: 5px;
  margin-top: 88px;
  padding: 0 30px;
}
.enable {
  font-size: 12px;
  color: #249e77;
  line-height: 16px;
}
.prohibit {
  font-size: 12px;
  color: #de5f5f;
  line-height: 16px;
}
.btn-span {
  font-size: 12px;
}
.btn-template {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
</style>
<style>
.has-gutter {
  line-height: 34px;
}
.el-message-box {
  width: auto;
}
.el-message-box__title {
  color: #333333 !important;
  font-size: 16px !important;
  height: 16px;
}
.el-message-box--center .el-message-box__header {
  padding: 15px 15px 15px;
  border-bottom: 1px solid #f5f6f9;
}
.el-button--small,
.el-button--small.is-round {
  padding: 9px 30px;
}
.el-button--mini,
.el-button--small {
  font-size: 14px;
}
.el-form-item__label {
  line-height: 34px;
  color: #666666;
}
.accountmanagement {
  overflow: hidden;
}
.accountmanagement .el-form-item__content,
.el-input__inner {
  height: 34px;
  line-height: 34px;
}
.accountmanagement .el-input__icon {
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/views/role/accountmanagement.vue